<template>
    <div class="bg-racing-stars-yellow dark:bg-gray-800">
        <div class="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
            <h2 class="text-3xl font-extrabold text-gray-800 dark:text-white sm:text-4xl">
                <span class="block">Start Playing Today</span>
                <span class="block">Sign Up Now</span>
            </h2>
            <p class="mt-4 text-lg leading-6 text-gray-700 dark:text-gray-200">Be in with a chance to win today's prizes!</p>
            <a href="#top" class="mt-8 bg-white border border-transparent rounded-md shadow px-5 py-3 inline-flex items-center text-base font-medium text-gray-800 hover:opacity-80 hover:text-white dark:bg-racing-stars-yellow dark:text-gray-800 dark:hover:opacity-80">
                Sign Up Today
            </a>
        </div>
    </div>
</template>

<script>
    import { computed } from 'vue'
    import moment from 'moment'

    export default {
        props: {
            nextRaceStartTime: String,
        },

        setup(props) {
            const nextRace = computed(() => {
                return props.nextRaceStartTime ? moment(props.nextRaceStartTime).format('h:mm a') : 'Tomorrow'
            })

            return {
                nextRace,
            }
        }
    }
</script>
